import React from 'react';
import { useTranslation } from 'react-i18next';
import { TbLanguage } from 'react-icons/tb';
import '../i18n';
import { languages, skillCategories } from '../data/profile';
import Reveal from './Reveal';
import './assets/css/skills.css';

const Skills = () => {
  const { t } = useTranslation();

  return (
    <section className="section section-alt" id="skills">
      <div className="section-inner">
        <Reveal className="section-header">
          <span className="section-eyebrow">{t('skills_eyebrow')}</span>
          <h2 className="section-title">{t('skills_title')}</h2>
          <p className="section-subtitle">{t('skills_subtitle')}</p>
        </Reveal>

        <div className="skills-grid">
          {skillCategories.map((cat, i) => (
            <Reveal key={cat.key} className={`skill-card ${cat.key}`} delay={(i % 3) * 0.08}>
              <div className="skill-card-head">
                <h3>{t(cat.key)}</h3>
                <span className="skill-count">{cat.skills.length}</span>
              </div>
              <ul className="skill-chips">
                {cat.skills.map(({ name, icon: Icon }) => (
                  <li key={name} className="skill-chip">
                    <Icon aria-hidden="true" />
                    <span>{name}</span>
                  </li>
                ))}
              </ul>
            </Reveal>
          ))}

          <Reveal className="skill-card languages-card" delay={0.16}>
            <div className="skill-card-head">
              <h3><TbLanguage aria-hidden="true" /> {t('languages_title')}</h3>
            </div>
            <ul className="lang-list">
              {languages.map((l) => (
                <li key={l.key}>
                  <div className="lang-row">
                    <span className="lang-name">{t(l.key)}</span>
                    <span className="lang-level">
                      {t(l.level)} <span className="cefr">{l.cefr}</span>
                    </span>
                  </div>
                  <div className="lang-meter" aria-hidden="true">
                    <span style={{ width: `${l.value}%` }} />
                  </div>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Skills;
